'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var style = {
  fill: "#2196f3",
  stroke: "none",
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeWidth: 1
};

var CustomJobFieldsAppIcon = function CustomJobFieldsAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 32.04 40.6",
    role: "img"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    style: style,
    d: "M28.17.05H9.6A3.82,3.82,0,0,0,5.88,3,3.86,3.86,0,0,0,3,5.87a3.82,3.82,0,0,0-3,3.72V36.73a3.83,3.83,0,0,0,3.82,3.82H22.45a3.81,3.81,0,0,0,3.72-3A3.86,3.86,0,0,0,29,34.73,3.82,3.82,0,0,0,32,31V3.87A3.82,3.82,0,0,0,28.17.05ZM24.35,36.73a1.9,1.9,0,0,1-1.9,1.89H3.88A1.89,1.89,0,0,1,2,36.73V9.59a1.9,1.9,0,0,1,1.89-1.9H22.45a1.9,1.9,0,0,1,1.9,1.9Zm2.85-2.86a1.9,1.9,0,0,1-.92,1.62V9.59a3.84,3.84,0,0,0-3.83-3.83H5.12a1.9,1.9,0,0,1,1.62-.92H25.31A1.89,1.89,0,0,1,27.2,6.73ZM30.06,31a1.88,1.88,0,0,1-.93,1.62V6.73a3.82,3.82,0,0,0-3.82-3.82H8A1.88,1.88,0,0,1,9.6,2H28.17a1.89,1.89,0,0,1,1.89,1.89Z"
  }), React__default["default"].createElement("path", {
    style: style,
    d: "M21,9.34a2.4,2.4,0,0,0-2.4,2.39,2.35,2.35,0,0,0,.17.86l-2.16,2.16a2.39,2.39,0,0,0-2.81.11l-1.91-1.15a2.13,2.13,0,0,0,.07-.55,2.4,2.4,0,1,0-4.79,0,2.31,2.31,0,0,0,.23,1L5.55,16.5l-.24,0a2.4,2.4,0,1,0,1.93,1l1.63-2a2.4,2.4,0,0,0,1.87-.19l2.19,1.32a.81.81,0,0,0,0,.16,2.39,2.39,0,0,0,4.78,0,1.37,1.37,0,0,0,0-.29L20.16,14A2.39,2.39,0,1,0,21,9.34Zm-15.72,10a.47.47,0,1,1,.47-.47A.47.47,0,0,1,5.31,19.34ZM9.6,13.62a.47.47,0,1,1,.46-.46A.47.47,0,0,1,9.6,13.62Zm5.71,3.57a.46.46,0,0,1-.46-.46.47.47,0,1,1,.93,0A.46.46,0,0,1,15.31,17.19Zm5.72-5a.46.46,0,0,1-.47-.46.47.47,0,1,1,.93,0A.46.46,0,0,1,21,12.19Z"
  }), React__default["default"].createElement("rect", {
    style: style,
    x: "4.35",
    y: "22.19",
    width: "17.64",
    height: "1.93"
  }), React__default["default"].createElement("rect", {
    style: style,
    x: "4.35",
    y: "25.05",
    width: "17.64",
    height: "1.93"
  }), React__default["default"].createElement("path", {
    style: style,
    d: "M8.17,27.91a4.54,4.54,0,1,0,4.53,4.53A4.54,4.54,0,0,0,8.17,27.91Zm0,7.14a2.6,2.6,0,0,1-2.41-1.64H7.85l1.67,1.25A2.52,2.52,0,0,1,8.17,35.05Zm-1-5v1.45H5.76A2.63,2.63,0,0,1,7.2,30Zm3.48,3.09L9.13,32V30a2.55,2.55,0,0,1,1.55,3.09Z"
  }), React__default["default"].createElement("rect", {
    style: style,
    x: "13.63",
    y: "28.62",
    width: "8.36",
    height: "1.93"
  }), React__default["default"].createElement("rect", {
    style: style,
    x: "13.63",
    y: "31.48",
    width: "8.36",
    height: "1.93"
  }), React__default["default"].createElement("rect", {
    style: style,
    x: "13.63",
    y: "34.34",
    width: "8.36",
    height: "1.92"
  })));
};

var CustomJobFieldsAppIcon$1 = iconStyles()(CustomJobFieldsAppIcon);

module.exports = CustomJobFieldsAppIcon$1;
